<template>
  <router-view v-if="!app"></router-view>
  <div class="list" v-else>
    <div v-for="(item, index) in routers" :key="`list-${index}`" style="margin-bottom: 0.05rem">
      <div v-if="!item.children" class="item">
        <span>{{ item.name }}</span>
        <a :href="'/webactivity' + item.path">{{ item.path }}</a>
      </div>
      <div v-else class="item has-children" >
        <div class="father-name">{{ item.name }}</div>
        <div class="father-bd">
          <div class="cl" v-for="(items, indexs) in item.children" :key="`children-${indexs}`">
            <em>{{ items.name }}</em><br/>
            <a :href="'/webactivity' + item.path + items.path">{{ `${item.path}${items.path}` }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from './router';
import { autoLaunch, env, compareVersion, JS2Native } from '@igetcool/base-components';

export default {
  data: () => {
    return {
      routers: [],
      app: false
    };
  },
  methods: {
    sortBy(name) {
      return function(a, b) {
        let c = a[name];
        let d = b[name];
        if (c < d) { return -1 }
        else if (c > d) { return 1 }
        else { return 0 }
      };
    }
  },
  created() {
    // 开发环境渲染一下路由目录，只在根目录渲染
    const appEnv = process.env.VUE_APP_ENVIRONMENT;
    this.app = appEnv !== 'PRODUCTION' && window.location.pathname === '/webactivity/';
    if (this.app) {
      let array = [
        ...router.options.routes
      ];
      this.routers = array.sort(this.sortBy('name'));
      this.dev = true;
    }
  },
  mounted() {
    autoLaunch.init();
    // app内关闭app原生的loading，只在app内生效，且版本大于6.16.0，且没有传入closeAppLoadingDisabled参数
    if (env.isApp && !this.$route.query.closeAppLoadingDisabled) {
      if (compareVersion(env.appVer, '6.16.0') >= 0) {
        JS2Native({
          name: 'closeAppLoading'
        });
      }
    }
  }
};
</script>

<style scoped>
.list {
  font-size: 16px;
  padding: 18px;
}
.has-children{
  display: flex;
  flex-direction: row;
}
.item{
  background: rgb(220, 223, 230);
  padding: 5px 10px;
  border: 1px solid #f5f5f5;
  border-radius: 8px;
  align-items: center;
}
.item span,
.father-name{
  font-size: 0.15rem;
  font-weight: bold;
  color: #303133;
  display: inline-block;
  width: 0.6rem;
  text-align: right;
  padding-right: 4px;
  margin-right: 4px;
}
.cl{
  padding-bottom: 0.02rem;
}
.cl em{
  font-size: 0.08rem;
  font-style: normal;
  font-weight: 300;
  color: #999
}
.item a{
  color: #303133;
  opacity: 0.69;
  text-decoration: none;
}
.item a:hover{
  text-decoration: underline;
}
</style>

<style>
* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  margin: 0;
  padding: 0;
}

html {
  height: 100% !important;
}

body {
  height: 100% !important;
  background-color: #fff;
}
.containers {
  margin-right: auto;
  margin-left: auto;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  min-width: 240px;
  max-width: 480px;
}

.container {
  margin-right: auto;
  margin-left: auto;
}

.containerRob {
  margin: 0 auto;
}

@media (min-width: 768px) {
  .containers {
    max-width: 750px;
  }

  .container {
    max-width: 750px;
  }

  .containerRob {
    max-width: 750px;
  }
}

@media (min-width: 992px) {
  .containers {
    max-width: 970px;
  }

  .container {
    max-width: 970px;
  }

  .containerRob {
    max-width: 970px;
  }
}

@media (min-width: 1200px) {
  .containers {
    max-width: 1200px;
  }

  .container {
    max-width: 1000px;
  }

  .containerRob {
    max-width: 1000px;
  }
}

.containersComments {
  margin-left: 0.2rem;
  margin-right: 0.2rem;
  min-width: 200px;
  max-width: 480px;
}

@media (min-width: 768px) {
  .containers {
    max-width: 750px;
  }

  .containersMix {
    max-width: 750px;
  }

  .containersComments {
    max-width: 690px;
  }
}

@media (min-width: 992px) {
  .containers {
    max-width: 970px;
  }

  .containersMix {
    max-width: 750px;
  }

  .containersComments {
    max-width: 970px;
  }
}

@media (min-width: 1200px) {
  .containers {
    max-width: 1000px;
  }

  .containersMix {
    max-width: 750px;
  }

  .containersComments {
    max-width: 1000px;
    margin: 0 auto;
  }
}
</style>

